import { Link } from "react-router-dom";

function Footer() {
    return (
        <footer
            className="p-2 text-white mt-5"
            style={{ fontSize: "2rem", backgroundColor: "#777", fontWeight: "bold" }}
        >
            <div className="footer mt-4 text-center text-white" style={{ fontSize: "0.9rem", color: "#444" }}>
                <p >
                    <Link to="/contact" style={{ color: "white" }} className="me-3">Contacto</Link>
                    <Link to="/about" style={{ color: "white" }}>Acerca de</Link>
                </p>
                <p>© 2024-2026 littlecoders.dev - Aprende Python mientras organizas tu día</p>
            </div>
        </footer>
    );
}

export default Footer;
